import React, { Component } from 'react'
import AddGift from './AddGift';
import AddNote from './AddNote';
import GiftCards from './GiftCards';
import ModalShell from '../common/ModalShell';
import WelcomeModal from './WelcomeModal';
import Notes from './Notes';
import { observer } from 'mobx-react';
import { Icon, Affix, Button, message, InputNumber } from 'utils/ui';
import _ from "underscore";
import { determineCategoryIcon } from '../utils/gifts/helpers.js'
import FamilyStore from '../stores/FamilyStore';
import { updateUserGiftRanks } from '../api_calls/user';
import User from '../models/UserModel';
import { appColours as themes } from '../utils/styles/colours';
import { FaBirthdayCake } from 'react-icons/fa';
import { assignRankToGift, getPersistedRankOrder } from '../utils/rankUtils';

// import AWS from "aws-sdk";

// var albumBucketName = "listgifts-pics";
// var bucketRegion = 'us-east-2';
// var IdentityPoolId = "us-east-2:e467c664-233b-4e2b-ac1f-36d6fb672768";


// AWS.config.update({
//   region: bucketRegion,
//   credentials: new AWS.CognitoIdentityCredentials({
//     IdentityPoolId: IdentityPoolId
//   })
// });

// var s3 = new AWS.S3({
//   apiVersion: "2006-03-01",
//   params: { Bucket: albumBucketName }
// });
@observer(["MyListStore", "UserStore", "FamilyStore", "AuthStore"])
class MyList extends Component {
    constructor(props) {
        super(props);
        const { FamilyStore } = this.props;
        this.state = { ranksDoneForGroupChange: true, multipleGroups: false, rankModalOpen: false, rankings: [], ranks: {}, startingRanks: {}, appColours: themes("default"), profileImageLoadFailed: false  };
        // this.listAlbums = this.listAlbums.bind(this);
        // this.createAlbum = this.createAlbum.bind(this);
        // this.viewAlbum = this.viewAlbum.bind(this);
        // this.addPhoto = this.addPhoto.bind(this);
        // this.deletePhoto = this.deletePhoto.bind(this);
        // this.deleteAlbum = this.deleteAlbum.bind(this);   
        this.onSubmitRankClick = this.onSubmitRankClick.bind(this);
        this.rankChanged = this.rankChanged.bind(this);
        this.clearGiftRank = this.clearGiftRank.bind(this);
        this.onProfileImageError = this.onProfileImageError.bind(this);
    }

    componentDidMount() {
        const { UserStore, MyListStore, FamilyStore } = this.props;
        if (typeof document !== "undefined") {
            document.body.classList.add("my-list-no-page-scroll");
            document.documentElement.classList.add("my-list-no-page-scroll");
        }
        if (FamilyStore.activeGroupId !== "") {
            const realUser = this.getViewUserId();
            MyListStore.loadGiftsForUser(realUser, realUser, FamilyStore.activeGroupId);
        }
        this.setState({
            currentGroup: FamilyStore.activeGroupId
        });
        this.syncRanksFromSource();
    }

    componentDidUpdate(prevProps) {
        const { UserStore, MyListStore, FamilyStore } = this.props;
        const prevUserId = this.getViewUserId(prevProps);
        const nextUserId = this.getViewUserId();
        const prevProfileImage = this.getCurrentProfileImage(prevProps);
        const nextProfileImage = this.getCurrentProfileImage();
        const viewChanged =
            FamilyStore.activeGroupId !== prevProps.FamilyStore.activeGroupId ||
            UserStore.childViewActive !== prevProps.UserStore.childViewActive ||
            prevUserId !== nextUserId;

        if (viewChanged) {
            if (FamilyStore.activeGroupId !== "") {
                MyListStore.loadGiftsForUser(nextUserId, nextUserId, FamilyStore.activeGroupId);
            }
        }

        if (viewChanged || MyListStore.loaded !== prevProps.MyListStore.loaded) {
            this.syncRanksFromSource();
        }

        if (this.state.profileImageLoadFailed && prevProfileImage !== nextProfileImage) {
            this.setState({ profileImageLoadFailed: false });
        }
    }

    componentWillUnmount() {
        if (typeof document !== "undefined") {
            document.body.classList.remove("my-list-no-page-scroll");
            document.documentElement.classList.remove("my-list-no-page-scroll");
        }
    }

    getViewUserId(props = this.props) {
        const { UserStore } = props;
        if (!UserStore.childViewActive) {
            return UserStore.user._id;
        }

        return UserStore.childView || (UserStore.activeChild && UserStore.activeChild.id) || UserStore.user._id;
    }

    getCurrentUser(props = this.props) {
        const { UserStore } = props;
        return UserStore.childViewActive
            ? _.findWhere(UserStore.children, { _id: this.getViewUserId(props) }) || UserStore.user
            : UserStore.user;
    }

    getCurrentProfileImage(props = this.props) {
        const { UserStore } = props;
        const currentUser = this.getCurrentUser(props);
        const imageSrc = currentUser && currentUser.profileImage;

        return imageSrc === "" || !imageSrc ? (UserStore.defaultImage || "img/default-user.png") : imageSrc;
    }

    getDisplayedProfileImage() {
        const { UserStore } = this.props;
        return this.state.profileImageLoadFailed ? (UserStore.defaultImage || "img/default-user.png") : this.getCurrentProfileImage();
    }

    onProfileImageError() {
        if (!this.state.profileImageLoadFailed) {
            this.setState({ profileImageLoadFailed: true });
        }
    }

    getCurrentGiftList() {
        const { UserStore, MyListStore } = this.props;
        if (UserStore.childViewActive) {
            return _.where(MyListStore.gifts, { wisher: this.getViewUserId() }) || [];
        }
        return MyListStore.myList || [];
    }

    buildRankMapForCurrentView() {
        const { FamilyStore } = this.props;
        const currentUser = this.getCurrentUser();
        const storedRanks = currentUser && currentUser.listRank ? currentUser.listRank.get(FamilyStore.activeGroupId) || [] : [];
        const giftIds = this.getCurrentGiftList().map(gift => gift._id);
        const currentRanks = {};

        storedRanks.forEach((giftId, index) => {
            if (giftIds.includes(giftId) && !currentRanks[giftId]) {
                currentRanks[giftId] = index + 1;
            }
        });

        return currentRanks;
    }

    syncRanksFromSource() {
        const { FamilyStore, UserStore } = this.props;
        if (!FamilyStore.activeGroupId) {
            return;
        }

        const currentRanks = this.buildRankMapForCurrentView();
        const nextState = {
            currentChildView: UserStore.childViewActive,
            currentGroup: FamilyStore.activeGroupId,
            startingRanks: { ...currentRanks },
            ranks: { ...currentRanks }
        };

        const shouldUpdate = JSON.stringify(this.state.ranks || {}) !== JSON.stringify(currentRanks)
            || JSON.stringify(this.state.startingRanks || {}) !== JSON.stringify(currentRanks)
            || this.state.currentGroup !== FamilyStore.activeGroupId
            || this.state.currentChildView !== UserStore.childViewActive;

        if (shouldUpdate) {
            this.setState(nextState);
        }
    }

    determineRanking() {
        this.syncRanksFromSource();
    }

    determineRankingChild() {
        this.syncRanksFromSource();
    }

    determineRankingGroup() {
        this.syncRanksFromSource();
    }

    // deleteAlbum(albumName) {
    //     var albumKey = encodeURIComponent(albumName) + "/";
    //     s3.listObjects({ Prefix: albumKey }, function(err, data) {
    //       if (err) {
    //         return alert("There was an error deleting your album: ", err.message);
    //       }
    //       var objects = data.Contents.map(function(object) {
    //         return { Key: object.Key };
    //       });
    //       s3.deleteObjects(
    //         {
    //           Delete: { Objects: objects, Quiet: true }
    //         },
    //         function(err, data) {
    //           if (err) {
    //             return alert("There was an error deleting your album: ", err.message);
    //           }
    //           alert("Successfully deleted album.");
    //           this.listAlbums();
    //         }
    //       );
    //     });
    //   }

    // deletePhoto(albumName, photoKey) {
    //     s3.deleteObject({ Key: photoKey }, function(err, data) {
    //       if (err) {
    //         return alert("There was an error deleting your photo: ", err.message);
    //       }
    //       alert("Successfully deleted photo.");
    //       this.viewAlbum(albumName);
    //     });
    //   }

    // addPhoto(albumName) {
    //     var files = document.getElementById("photoupload").files;
    //     if (!files.length) {
    //       return alert("Please choose a file to upload first.");
    //     }
    //     var file = files[0];
    //     var fileName = file.name;
    //     var albumPhotosKey = encodeURIComponent(albumName) + "/";

    //     var photoKey = albumPhotosKey + fileName;

    //     // Use S3 ManagedUpload class as it supports multipart uploads
    //     var upload = new AWS.S3.ManagedUpload({
    //       params: {
    //         Bucket: albumBucketName,
    //         Key: photoKey,
    //         Body: file,
    //         ACL: "public-read"
    //       }
    //     });

    //     var promise = upload.promise();

    //     promise.then(
    //       function(data) {
    //         alert("Successfully uploaded photo.");
    //         this.viewAlbum(albumName);
    //       },
    //       function(err) {
    //         return alert("There was an error uploading your photo: ", err.message);
    //       }
    //     );
    //   }

    // viewAlbum(albumName) {
    //     let thisSelf = this;
    //     var albumPhotosKey = encodeURIComponent(albumName) + "/";
    //     s3.listObjects({ Prefix: albumPhotosKey }, function(err, data) {
    //       if (err) {
    //         return alert("There was an error viewing your album: " + err.message);
    //       }
    //       // 'this' references the AWS.Response instance that represents the response
    //       var href = this.request.httpRequest.endpoint.href;
    //       var bucketUrl = href + albumBucketName + "/";

    //       var photos = data.Contents.map(function(photo) {
    //         var photoKey = photo.Key;
    //         var photoUrl = bucketUrl + encodeURIComponent(photoKey);
    //         return [
    //           <span>,
    //           <div>,
    //           <img style="width:128px;height:128px;" src={' + photoUrl + '}/>,
    //           </div>,
    //           <div>,
    //           <span onclick={thisSelf.deletePhoto('" + albumName + "','" + photoKey + "')}>,
    //           "X",
    //           </span>,
    //           <span>,
    //           {photoKey.replace(albumPhotosKey, "")},
    //           </span>,
    //           </div>,
    //           </span>
    //         ].join('\n');
    //       });
    //       var message = photos.length
    //         ? <p>Click on the X to delete the photo</p>
    //         : <p>You do not have any photos in this album. Please add photos.</p>;
    //       var htmlTemplate = [
    //         "<h2>",
    //         "Album: " + albumName,
    //         "</h2>",
    //         message,
    //         "<div>",
    //         photos.join('\n'),
    //         "</div>",
    //         '<input id="photoupload" type="file" accept="image/*">',
    //         '<button id="addphoto" onclick="addPhoto(\'' + albumName + "')\">",
    //         "Add Photo",
    //         "</button>",
    //         '<button onclick="listAlbums()">',
    //         "Back To Albums",
    //         "</button>"
    //       ];
    //       document.getElementById("app").innerHTML = htmlTemplate.join('\n');
    //     });
    //   }

    // createAlbum(albumName) {
    //     albumName = albumName.trim();
    //     if (!albumName) {
    //       return alert("Album names must contain at least one non-space character.");
    //     }
    //     if (albumName.indexOf("/") !== -1) {
    //       return alert("Album names cannot contain slashes.");
    //     }
    //     var albumKey = encodeURIComponent(albumName);
    //     s3.headObject({ Key: albumKey }, function(err, data) {
    //       if (!err) {
    //         return alert("Album already exists.");
    //       }
    //       if (err.code !== "NotFound") {
    //         return alert("There was an error creating your album: " + err.message);
    //       }
    //       s3.putObject({ Key: albumKey }, function(err, data) {
    //         if (err) {
    //           return alert("There was an error creating your album: " + err.message);
    //         }
    //         alert("Successfully created album.");
    //         this.viewAlbum(albumName);
    //       });
    //     });
    //   }

    // listAlbums() {
    //   console.log("L:ISTING ALBUMS");
    //   let self = this;

    //     s3.listObjects({ Delimiter: "/" }, function(err, data) {
    //       if (err) {
    //         return alert("There was an error listing your albums: " + err.message);
    //       } else {
    //          console.log(data);
    //          self.setState({albums: data.Contents.map(album =>  <div>{album.Key}</div>)});      

    //       }
    //     });
    //   }  

    onSubmitRankClick() {
        const { FamilyStore, UserStore, AuthStore } = this.props;
        const maxRank = Number(FamilyStore.activeGroup && FamilyStore.activeGroup.settings && FamilyStore.activeGroup.settings.rankingMax) || 1;
        const persistedRanks = getPersistedRankOrder(this.state.ranks, maxRank);

        if (!persistedRanks) {
            message.warn("Must have unique rankings within the allowed rank range");
            return;
        }

        this.setState({ rankModalOpen: false });
        let userId = UserStore.childViewActive ? UserStore.activeChild.id : UserStore.user._id;
        let token = UserStore.childViewActive ? UserStore.activeChild.jwt : AuthStore.userAuth.auth.accessToken;
        updateUserGiftRanks(userId, token, FamilyStore.activeGroupId, persistedRanks).then((res) => {
            if (res && res.status === 200) {
                message.success("Ranks updated!");
                UserStore.refreshUser(AuthStore.userAuth.auth.accessToken, FamilyStore.activeGroupId);
            }
            else {
                message.error("Problem updating ranks...");
            }
        });
    }

    rankChanged(gift, value) {
        const maxRank = Number(FamilyStore.activeGroup && FamilyStore.activeGroup.settings && FamilyStore.activeGroup.settings.rankingMax) || 1;
        const ranks = assignRankToGift(this.state.ranks, gift._id, value, maxRank);
        this.setState({ ranks });
    }

    clearGiftRank(giftId) {
        const ranks = assignRankToGift(this.state.ranks, giftId, undefined, Number(FamilyStore.activeGroup && FamilyStore.activeGroup.settings && FamilyStore.activeGroup.settings.rankingMax) || 1);
        this.setState({ ranks });
    }

    formatBirthday(month, day) {
        if (!month || !day) {
            return "Not set";
        }
        const date = new Date(2000, month - 1, day);
        return date.toLocaleDateString(undefined, { month: "long", day: "numeric" });
    }

    render() {
        const { MyListStore, UserStore, FamilyStore } = this.props;
        let notes;
        let giftsToMap = [];

        if (UserStore.childViewActive) {
            if (UserStore.activeChild.id) {
                notes = _.findWhere(UserStore.children, { _id: UserStore.activeChild.id }) ? _.findWhere(UserStore.children, { _id: UserStore.activeChild.id }).notes : [];
                giftsToMap = _.where(MyListStore.gifts, { wisher: UserStore.activeChild.id }) ? _.where(MyListStore.gifts, { wisher: UserStore.activeChild.id }) : [];
            } else {
                notes = [];
            }
        } else {
            notes = UserStore.user.notes;
            giftsToMap = MyListStore.myList;
        }

        const activeUser = this.getCurrentUser();
        const sourceRankOrder = activeUser && activeUser.listRank ? activeUser.listRank.get(FamilyStore.activeGroupId) || [] : [];
        const rankFallback = {};
        sourceRankOrder.forEach((giftId, index) => {
            if (giftsToMap.some(gift => gift._id === giftId)) {
                rankFallback[giftId] = index + 1;
            }
        });
        const displayRanks = Object.keys(this.state.ranks || {}).length ? this.state.ranks : rankFallback;

        const profileBirthMonth = UserStore.childViewActive ? UserStore.activeChild.birthMonth : UserStore.user.birthMonth;
        const profileBirthDay = UserStore.childViewActive ? UserStore.activeChild.birthDay : UserStore.user.birthDay;
        const profileImage = this.getDisplayedProfileImage();
        const birthdayText = this.formatBirthday(profileBirthMonth, profileBirthDay);
        const menuButtonStyle = {
            border: 'none',
            textAlign: 'center',
            padding: '15px',
            cursor: 'pointer',
            backgroundColor: UserStore.theme().icons || "white",
            color: UserStore.theme().font2 || "black",
            borderRadius: '40px',
            marginLeft: "5px",
            marginRight: "5px",
            marginTop: "5px"
        };
        return (
            <div className="my-list-shell" style={{
                backgroundColor: UserStore.theme().appBackground || "white",
                minHeight: "100vh"
            }}>
            <ModalShell
                className="rank-modal"
                overlayClassName="rank-modal-overlay"
                isOpen={this.state.rankModalOpen}
                onRequestClose={this.determineRanking.bind(this)}
                top="36%"
                maxWidth={600}
            >
                <div className="ui-modal-surface-light" style={{ maxWidth: '600px' }}>
                <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
                textAlign: 'center'
                }}>
                <h2 style={{ color: '#222' }} className="AppFont ui-modal-form-title">Rank your gifts in order of preference</h2>
                <h4 style={{ color: '#222' }} className="AppFont">your group admin has set the max rank to: {FamilyStore.activeGroup.settings.rankingMax}</h4>

                {giftsToMap.map(gift => <div className="AppFont" style={{ textAlign: "center", padding: "7px", color: UserStore.theme().font  }}>
                    {determineCategoryIcon(gift.category, 15)} {gift.title} <span>
                    <InputNumber max={Math.min(giftsToMap.length, FamilyStore.activeGroup.settings.rankingMax)} onChange={this.rankChanged.bind(this, gift)}
                        defaultValue={this.state.startingRanks[gift._id] || null} value={this.state.ranks[gift._id] || null} min={1} />
                    <span style={{ fontSize: 12, marginLeft: "7px" }}><Button size="small" onClick={this.clearGiftRank.bind(this, gift._id)}>Clear</Button></span>
                    </span>
                </div>)}
                <div className="ui-modal-actions">
                    <Button className="AppFont btn-submit ui-btn-success" onClick={this.onSubmitRankClick.bind(this)} size="large"><Icon type="check-circle" /> Submit</Button>
                    <Button className="AppFont btn-cancel ui-btn-danger" onClick={() => { this.setState({ rankModalOpen: false, ranks: this.state.startingRanks }) }} size="large"><Icon type="close" /> Cancel</Button>
                </div>
                </div>
                </div>
            </ModalShell>

            {UserStore.user.isWelcomeMessageDismissed ?
                <div className="my-list-layout-root">
                <div className="my-list-fixed-actions" style={{
                    position: "fixed", 
                    zIndex: 999, 
                    width: "100%",
                    top: "var(--app-header-height)",
                    padding: "10px 20px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    display: "flex",
                    alignItems: "center",
                    
                }}>
                    <AddGift divStyle={{...menuButtonStyle, transition: "all 0.2s ease"}} />
                    <AddNote divStyle={{...menuButtonStyle, transition: "all 0.2s ease"}} />
                    {FamilyStore.activeGroup && FamilyStore.activeGroup.settings.allowRankings ?
                    <div style={{
                        ...menuButtonStyle,
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '8px 12px',
                        borderRadius: '8px',
                        color: '#fff',
                        cursor: 'pointer',
                        userSelect: 'none',
                        fontWeight: '600',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 2px 4px rgba(74,144,226,0.2)'
                    }} onClick={() => { this.props.MyListStore.myList.length == 0 ? message.warn("You must have gifts listed to rank them!") : this.setState({ rankModalOpen: true }) }}>
                        <Icon style={{fontSize: "16px"}} type="star" />Rank Gifts
                    </div>
                    : null}
                </div>
                <div style={{ 
                    color: UserStore.theme().font || "#333",
                }} className="AppFont my-list-content-wrap">
                    <div className="list-two-column-layout with-fixed-actions">
                        <aside className="list-profile-rail">
                            <div className="list-profile-card">
                                <img alt="" className="list-profile-avatar" src={profileImage} onError={this.onProfileImageError} />
                                <div>
                                    <div className="list-profile-name AppFont">{UserStore.childViewActive ? `${UserStore.activeChild.name}'s List` : "Your List"}</div>
                                    <div className="list-profile-role"></div>
                                    <div className="list-profile-birthday">
                                        <div className="list-profile-birthday-label"><FaBirthdayCake style={{ marginRight: 6 }} /> Birthday</div>
                                        <div className="list-profile-birthday-value">{birthdayText}</div>
                                    </div>
                                </div>
                            </div>
                        </aside>

                        <section className="list-main-pane my-list-main-pane">
                            {notes.length === 0 ? null : <Notes notes={notes} />}
                            <div className="my-list-gifts-scroll">
                                {FamilyStore.activeGroupId === "" ? "" : MyListStore.loading ? <Icon type="loading" /> :
                                    (MyListStore.myList.length > 0 ?
                                    <div style={{ marginTop: "0" }}>
                                        <GiftCards sort={FamilyStore.activeGroup && FamilyStore.activeGroup.settings.allowRankings} ranks={displayRanks} gifts={UserStore.childViewActive ? _.where(MyListStore.gifts, { wisher: UserStore.activeChild.id }) : MyListStore.myList} />
                                    </div>
                                    : <h1 className="AppFont" style={{ color: UserStore.theme().font || "#333", marginTop: "20%" }}>No gifts found</h1>)}
                            </div>
                        </section>
                    </div>
                </div>
                </div>
                : <WelcomeModal />}
            </div>
        )
    }
}
export default MyList;